import script from "./Designation.vue?vue&type=script&setup=true&lang=js"
export * from "./Designation.vue?vue&type=script&setup=true&lang=js"

import "./Designation.vue?vue&type=style&index=0&id=5a2283ed&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a2283ed"]])

export default __exports__